import { makeStyles } from '@material-ui/core/styles'

// Any time that we would like to add CSS to our Components we will create a styles object. The syntax is different then normal CSS. Please notice that camel case is used to set the list-style-type. For your reference please visit https://v4.mui.com
export const didYouKnowWidgetStyles = makeStyles((theme) => ({
  gridContainer: {
    paddingRight: 10,
    paddingLeft: 10,
    height: 478,
    overflowY: 'clip',
    margin: 0,
    width: 335,
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  categoriesList: {
    listStyleType: 'none',
    padding: '0px',
  },
}))

export default didYouKnowWidgetStyles
